import { db, firebaseEnabled } from '../firebase'
import { doc, getDoc, setDoc } from 'firebase/firestore'

const LS_PREFIX = 'etimad_settings_'

// Generic key-value settings store, used for things like the voucher/
// invoice auto-numbering counters. `key` is a short name (e.g. 'vouchers'),
// `defaults` is returned/merged when nothing has been saved yet.
export async function getSettings(key, defaults) {
  if (firebaseEnabled) {
    const snap = await getDoc(doc(db, 'settings', key))
    return snap.exists() ? { ...defaults, ...snap.data() } : defaults
  }
  const raw = localStorage.getItem(LS_PREFIX + key)
  if (!raw) return defaults
  try {
    return { ...defaults, ...JSON.parse(raw) }
  } catch (e) {
    return defaults
  }
}

export async function setSettings(key, values) {
  if (firebaseEnabled) {
    await setDoc(doc(db, 'settings', key), values)
    return
  }
  localStorage.setItem(LS_PREFIX + key, JSON.stringify(values))
}
